<template>
  <section>
<el-dialog
      :title="ttle"
      :visible.sync="showAdd"
      width="1200px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <div>
        <el-form
         v-if="showAdd"
          class="myform"
          :rules="rules"
          ref="addShipLineInfoRef"
          label-position="left"
          :disabled = "showsave"
          label-width="80px"
          :model="addShipLineInfo.shipline[0]"
        >
          <div style="display: flex;">
            <div class="sp_add_left">
              <el-form-item label="船期" prop="shipTime">
                <el-date-picker
                  style="width: 100%;"
                  v-model="addShipLineInfo.shipline[0].shipTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择船期"
                ></el-date-picker>
              </el-form-item>

              <el-form-item
                label="航次号"
                prop="voyageNumber"
                v-if="isAddMode"
                style="overflow:hidden"
              >
                <el-input
                  placeholder="输入航次号"
                  v-model="addShipLineInfo.shipline[0].voyageNumber"
                  style="width:60%;float: left "
                ></el-input>
                <span
                  @click="generatevoyageNumber"
                  style=" width:39%;color: #1A67FF; cursor: pointer;text-overflow: ellipsis"
                >生成航次号</span>
              </el-form-item>
              <el-form-item label="航次号" prop="voyageNumber" v-if="!isAddMode" class="myclass">
                <el-input
                  placeholder="输入航次号"
                  v-model="addShipLineInfo.shipline[0].voyageNumber"
                  :disabled="true"
                ></el-input>
              </el-form-item>

<!--              <el-form-item label="指导价格" prop="freightRate">-->
<!--                <el-input placeholder="输入指导价格" v-model="addShipLineInfo.freightRate">-->
<!--                  <template slot="append">元/吨</template>-->
<!--                </el-input>-->
<!--              </el-form-item>-->

              <el-form-item label="滞期费率" prop="demurrage" class="myclass">
                <el-input placeholder="请输入滞期费率" v-model="addShipLineInfo.shipline[0].demurrage"
                          style="width:60%;float: left" v-if="demurrage">
                  <template slot="append">元/吨天</template>
                </el-input>
                <el-input placeholder="请输入滞期费率" v-model="addShipLineInfo.shipline[0].demurrageTonnage"
                          style="width:60%;float: left" v-if="!demurrage">
                  <template slot="append">元/天</template>
                </el-input>
                <span
                  @click="changgedemurrage"
                  style=" width:39%;color: #1A67FF; cursor: pointer;text-overflow: ellipsis"
                >切换类型</span>
              </el-form-item>
              <el-form-item label="装卸时间" prop="upDownLoadingTime" class="myclass">
                <el-input placeholder="请输入装卸时间" v-model="addShipLineInfo.shipline[0].upDownLoadingTime">
                  <template slot="append">天</template>
                </el-input>
              </el-form-item>
              <el-form-item label="租船员" prop="findShipUser" v-if="addShipLineInfo.shipline[0].businessType !==10">
                <template #label v-if="addShipLineInfo.shipline[0].contractId && addShipLineInfo.shipline[0].contractSpStatus === 2">
                  <el-tooltip class="item" effect="dark" content="合同发起后不能修改租船员" placement="top">
                    <span>租船员<i class="vxe-icon--question"></i></span>
                  </el-tooltip>
                </template>
                <PanelSimpleSelection
                  @setVal="setZuchuanyuan"
                  :allData="userListyewu"
                  :disabled="addShipLineInfo.shipline[0].contractId && addShipLineInfo.shipline[0].contractSpStatus === 2"
                  modeName="租船员"
                  keyStr="id"
                  valStr="name"
                  dataKey="common_yewuyuan"
                  ref="yewuyuan"
                ></PanelSimpleSelection>
              </el-form-item>
              <el-form-item label="付款周期"  class="myclass">
                <el-input placeholder="请输入付款周期" v-model="addShipLineInfo.shipline[0].paymentCycle">
                </el-input>
              </el-form-item>
              <el-form-item label="离港日期" prop="epartureTimeDate">
                <el-date-picker
                  style="width: 100%;"
                  v-model="addShipLineInfo.shipline[0].epartureTimeDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择离港日期"
                ></el-date-picker>
              </el-form-item>
                <el-form-item label="核算" prop="accountingType" style="text-align:left;">
                  <el-radio v-for="(item,index) in accountingTypeList" :key="index" v-model="addShipLineInfo.shipline[0].accountingType"  :label="item.value" >{{item.label}}</el-radio>
              </el-form-item>
              <el-form-item prop="contractCode" label="合同公司" style="display: inline-block; " >
                <el-tag style="margin-right: 10px;cursor: pointer;" :type="contractCode==item2.code?'success':'info'"
                        v-for="(item2,index) in  hetongTypelist" :key="index" @click="selectHetong(item2)"
                >{{item2.value}}</el-tag>
              </el-form-item>
            </div>

            <div class="sp_add_right">

              <!-- <el-form-item>
                <div style="  width: 100%;text-align: right;">
                  <el-button type="primary"  @click="addTab(editableTabsValue)" v-if="!showsave">添加船价</el-button>
                </div>
              </el-form-item> -->

              <el-form-item label="船名" prop="shipId">
                <NewPanelQuerySelection
                  @setVal="setShip"
                  modeName="船舶"
                  open-quick-save
                  data-key="shiplist"
                  ref="shipred"
                ></NewPanelQuerySelection>
              </el-form-item>
              <el-form-item label="定金" prop="dingjin" class="myclass">
                <el-input placeholder="请输入定金" v-model="addShipLineInfo.shipline[0].dingjin">
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
              <el-form-item label="船舶类型">
                <SimplePanelSelection
                  @setVal="setShipLeixing"
                  :allData="shipBusinessTypeList"
                  modeName="船舶类型"
                  keyStr="code"
                  valStr="value"
                  addDictionaryKey="ship_business_type"
                  ref="chuanboleixing"
                ></SimplePanelSelection>
              </el-form-item>
              <el-form-item label="单证员" prop="danzhengUser">

                <PanelSimpleSelection
                  @setVal="setDanzhengyuan"
                  :allData="danZhengList"
                  modeName="单证员"
                  keyStr="id"
                  valStr="name"
                  dataKey="common_danzhengUser"
                  ref="danzhengUser"
                ></PanelSimpleSelection>
              </el-form-item>
              <el-form-item label="船东">
                <PanelSelection @setVal="setSupplier" :allData="supplierList"
                                modeName="公司名称" dataKey="common_supplier"   keyStr="id" valStr="simpleName"
                                ref="supplier"
                ></PanelSelection>
              </el-form-item>
              <el-form-item label="船东结算公司" class="chuandongjiesuan" prop="settleCompany">
                <PanelSimpleSelection @setVal="setSettleSupplier" :allData="settleCompanyList"
                                modeName="公司名称" keyStr="id" valStr="name"
                                ref="settleSupplier"
                ></PanelSimpleSelection>
              </el-form-item>
              <el-form-item label="差异挂账"  style="display: inline-block;width: 590px;text-align: left;" >
                <el-switch
                  v-model="kaiguan"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                >
                </el-switch>
              </el-form-item>
              <el-form-item v-if="isShow" label="报港公司"  style="display: inline-block;width: 590px;text-align: left;" >
                <el-tag  style="margin-right: 10px;cursor: pointer;" :type="recontractCode==item2.code?'success':'info'"
                         v-for="(item2,index) in  reportPortCompany" :key="index" @click="selectReportPortCompany(item2.code)"
                >{{item2.value}}</el-tag>
              </el-form-item>
            </div>
          </div>
            <div style="display: flex;justify-content: space-between;">


            </div>
            <el-form-item
              label="选择航线"
              style=" cursor:pointer;text-align: left;margin-bottom: 0px"
              prop="sysShiplineId"
            >
              <el-tag
                v-for="(item,index) in linelist"
                :key="index"
                :type="addShipLineInfo.shipline[0].sysShiplineId==item.id?'warning':'info'"
                style="margin-right: 20px;"
                @click="selectline(item)"
              >
                <p
                  style="position: relative;top:-10px"
                  v-if="item.port1 && item.port2 "
                >{{item.port1}}-{{item.port2}}</p>
                <p
                  style="position: relative;top:-10px"
                  v-if="item.port1 === '' || item.port2 === ''"
                >{{item.lineName}}</p>
              </el-tag>
              <div style="  width: 100%;text-align: right;">
                  <el-button type="primary"  @click="addTab(editableTabsValue)" v-if="!showsave">添加船价</el-button>
                </div>
            </el-form-item>


          <el-tabs v-model="editableTabsValue" type="card" closable
                   @tab-click="clickTab"
                   @tab-remove="removeTab"
          style="width: 95%">
            <el-tab-pane
              v-for="(items, index) in addShipLineInfo.editableTabs"
              :key="items.name"
              :label="items.title"
              :name="items.name"
            >
              <div style="display: flex;margin-bottom: 20px;margin-top: 10px">
                <div style="margin-right: 20px">是否包船价</div>
                <el-switch
                  v-model="items.isBaochuanMoney"
                  active-color="#13ce66"
                  inactive-color="#999999">
                </el-switch>
              </div>

              <div style="display: flex;line-height: 10px;align-items: center;" v-if="items.isBaochuanMoney">
                <el-form-item label="包船金额" prop="baochuanMoney" style="width: 35%; " class="myclass" >
                  <el-input placeholder="请输入包船金额" v-model="items.baochuanMoney"></el-input>
                </el-form-item>
                <div @click="calculatePrice(index)" style="width: 15%;text-align: left;padding-left: 2px;color: #35BC20;cursor: pointer;">
                  计算船东价格
                </div>
                <el-form-item label="预估吨位" style="width: 45%;text-align: left" class="myclass" prop="yuguSettleTonnage">
                  <el-input v-model="items.yuguSettleTonnage" placeholder="输入预估吨位" step="0.01">
                    <template slot="append">吨</template>
                  </el-input>
                </el-form-item>
              </div>
              <div style="display: flex;line-height: 10px;">
                  <el-form-item label="船东价格" prop="shipPay" style="width: 45%; margin-right: 5%;" class="myclass">
                    <el-input placeholder="请输入运价" v-model="items.shipPay"></el-input>
                  </el-form-item>
                  <el-form-item label="税率" prop="payBill" style="width: 45%;text-align: left">
                    <el-radio-group v-model="items.payBill" size="medium">
                      <el-tag style="margin-right: 10px;cursor: pointer;" :type="items.payBill==item.code?'success':'info'"
                              v-for="(item,index) in  dictionaryLists['bill_tax']" :key="index" @click="leixingaddtaxpb(item.code)"
                      >{{item.value}}</el-tag>
                    </el-radio-group>
                  </el-form-item>
              </div>
              <div style="display: flex;line-height: 10px;">
<!--                <el-form-item style="width: 45%;text-align: left"  label="合同公司">-->
<!--                  <el-radio-group  v-model="items.company" size="medium">-->
<!--                    <el-tag style="margin-right: 10px;cursor: pointer;" :type="items.company==item2.code?'success':'info'"-->
<!--                            v-for="(item2,index) in  hetongTypelist" :key="index" @click="leixingaddtaxCC(item2.code)"-->
<!--                    >{{item2.value}}</el-tag>-->
<!--                  </el-radio-group>-->
<!--                </el-form-item>-->
              </div>
              <div style="display: flex;line-height: 10px;align-items: center;">
                <el-form-item label="起始港" style="width: 35%; "  class="myclass">
                  <PanelQuerySelection
                    @setVal="setStartPort"
                    modeName="港口"
                    :open-quick-save="true"
                    data-key="common_port"
                    ref="start"
                  ></PanelQuerySelection>
                </el-form-item>
                <div @click="matchingHeSuanQuYu()" style="width: 15%;text-align: left;padding-left: 2px;color: #35BC20;cursor: pointer;">
                  匹配核算区域
                </div>
                <el-form-item label="装载码头" style="width: 45%;text-align: left" class="myclass">
                  <PanelSelection @setVal="setZhuangzai" :allData="wharfList"
                                  modeName="码头" dataKey="common_wharf"   keyStr="id" valStr="wharf"
                                  addUrl="/tms/sysWharf/saveWharf"
                                  ref="zhuangzai"
                  ></PanelSelection>
                </el-form-item>
              </div>
              <div style="display: flex;line-height: 10px;">
                <el-form-item label="目的港" style="width: 45%; margin-right: 5%;"  class="myclass">
                  <PanelQuerySelection
                    @setVal="setEndPort"
                    modeName="港口"
                    :open-quick-save="true"
                    data-key="common_port"
                    ref="endport"
                  ></PanelQuerySelection>
                </el-form-item>
                <el-form-item label="卸货码头" style="width: 45%;text-align: left" class="myclass">
                  <PanelSelection @setVal="setMudi" :allData="wharfList"
                                  modeName="码头" dataKey="common_wharf"   keyStr="id" valStr="wharf"
                                  addUrl="/tms/sysWharf/saveWharf"
                                  ref="mudi"
                  ></PanelSelection>
                </el-form-item>
              </div>
              <div style="display: flex;line-height: 10px;">
                <el-form-item label="起始港2" style="width: 45%; margin-right: 5%;"  class="myclass">
                  <PanelQuerySelection
                    @setVal="setStartPort2"
                    modeName="港口"
                    :open-quick-save="true"
                    data-key="common_port"
                    ref="start2"
                  ></PanelQuerySelection>
                </el-form-item>
                <el-form-item label="装载码头2" style="width: 45%;text-align: left" class="myclass">
                  <PanelSelection @setVal="setZhuangzai2" :allData="wharfList"
                                  modeName="码头" dataKey="common_wharf"   keyStr="id" valStr="wharf"
                                  addUrl="/tms/sysWharf/saveWharf"
                                  ref="zhuangzai2"
                  ></PanelSelection>
                </el-form-item>
              </div>
              <div style="display: flex;line-height: 10px;">
                <el-form-item label="目的港2" style="width: 45%; margin-right: 5%;"  class="myclass">
                  <PanelQuerySelection
                    @setVal="setEndPort2"
                    modeName="港口"
                    :open-quick-save="true"
                    data-key="common_port"
                    ref="endport2"
                  ></PanelQuerySelection>
                </el-form-item>
                <el-form-item label="卸货码头2" style="width: 45%;text-align: left" class="myclass">
                  <PanelSelection @setVal="setMudi2" :allData="wharfList"
                                  modeName="码头" dataKey="common_wharf"   keyStr="id" valStr="wharf"
                                  addUrl="/tms/sysWharf/saveWharf"
                                  ref="mudi2"
                  ></PanelSelection>
                </el-form-item>
              </div>
              <div style="display: flex;line-height: 10px;">
                <el-form-item label="保底吨位" style="width: 45%;margin-right: 5%;" class="myclass" prop="bottomTonnage">
                  <el-input v-model="items.bottomTonnage" placeholder="输入保底吨位" step="0.01">
                    <template slot="append">吨</template>
                  </el-input>
                </el-form-item>
                <el-form-item label="结算吨位" style="width: 45%;text-align: left" class="myclass" prop="settleTonnage">
                  <el-input v-model="items.settleTonnage" placeholder="输入结算吨位" step="0.01">
                    <template slot="append">吨</template>
                  </el-input>
                </el-form-item>
              </div>
              <div style="display: flex;line-height: 10px;">
                <el-form-item label="货种" prop="goodsType"  style="width: 45%;margin-right: 5%;" class="myclass">
                  <SimplePanelSelection
                    @setVal="setHLeixing" :allData="huowuTypelist"
                    modeName="货种" keyStr="code"  valStr="value"
                    addDictionaryKey="goods_type"
                    ref="huowuleixing"
                  ></SimplePanelSelection>
                </el-form-item>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button key="besure" type="primary" @click="saveShipLine" v-if="isAddMode && !showsave">确 定</el-button>
        <el-button @click="updateShipLine" v-if="!isAddMode && !showsave" :disabled="disabledUpdate">确 定</el-button>
        <el-tooltip v-show="!isAddMode && !showsave && !((addShipLineInfo.shipline[0].danzhengUser==null||addShipLineInfo.shipline[0].danzhengUser=='') || addShipLineInfo.shipline[0].danzhengUser == $store.getters.getMyUserInfo.id)" style="position:relative; left: 10px;" effect="dark" content="您不是该船期的单证员，无法编辑" placement="top-end">
          <i class="el-icon-warning"></i>
        </el-tooltip>
        <!-- {{!((addShipLineInfo.shipline[0].danzhengUser==null||addShipLineInfo.shipline[0].danzhengUser=='') || addShipLineInfo.shipline[0].danzhengUser == $store.getters.getMyUserInfo.id)}} -->
      </span>
    </el-dialog>
      </section>
</template>
<script>
import NewPanelQuerySelection from "../common/newPanelQuerySelection";
import PanelQuerySelection from "../common/panelQuerySelection";
import PanelSelection from '../common/panelSelection'
import {getAllSysSupplier, getSettleCompanyList} from "../../api/syssupplier";
import SimplePanelSelection from "../common/simplePanelSelection";
import PanelSimpleSelection from "../common/panelSimpleSelection";

import {
  saveShipLine1,
  genVoyageNumber,
  getShipPayByShipLineId,
  updateShipLineNew
} from "../../api/shipline";
import { ERR_OK } from "../../jslib/config";
import { getDictionaryList } from "../../api/sysdictionary";
import { getIndependentSysShipLine } from "../../api/sysshipline";
import {getAllSysWharf} from "../../api/sysWharf";
// import {BASE_ACCOUNT_TYPE_LIST} from '../../jslib/config'
export default {
  data() {
    return {
      ttle:"新增船期",
      accountingTypeList: [],
      showsave:false,
      isShow: false,
      wharfList:[],
      diancompanylist:[],
      maicompanylist:[],
      showVirtualChecked:false,
        shiptype:2,
      shiplistlength: "",
      queryForm: {},
      dictionaryLists: {},
      tableData: [],
      total: 0,
      pageNo: 1,
      pageSize: 7,
      huowuTypelist:[],
      voyageNumberlist: [],
      hetongTypelist:[],
      reportPortCompany: [],
      rules: {
        accountingType:[
          {required: true,  message: '请选择核算类型', trigger: 'blur'},
        ],
        voyageNumber:[
          {required: true,  message: '请输入航次号', trigger: 'blur'},
        ],
        shipTime: [{ required: true, message: "请选择船期", trigger: "blur" }],
        sysShiplineId: [
          { required: true, message: "请选择航线", trigger: "blur" },
        ],
        contractCode: [
          { required: true, message: "请选择合同公司", trigger: "blur" },
        ],
        demurrage: [
          {
            type: "number",
            message: "滞期费率必须为数字值",
            transform(value) {
              if (value == undefined) {
                return null;
              }
              return Number(value);
            },
          },
        ],
        upDownLoadingTime: [
          {
            type: "number",
            message: "装卸时间必须为数字值",
            transform(value) {
              if (value == undefined) {
                return null;
              }
              return Number(value);
            },
          },
        ],
        dingjin: [
          {
            type: "number",
            message: "定金必须为数字值",
            transform(value) {
              if (value == undefined) {
                return null;
              }
              return Number(value);
            },
          },
        ],
        VoyageNumber: [
          { required: true, message: "请输入航次号", trigger: "blur" },
          {
            type: "number",
            message: "航次号必须为数字值",
            transform(value) {
              if (value == undefined) {
                return null;
              }
              return Number(value);
            },
          },
        ],
        freightRate: [
          {
            type: "number",
            message: "指导价格必须为数字值",
            transform(value) {
              if (value == undefined) {
                return null;
              }
              return Number(value);
            },
          },
        ],
        settleTonnage:
          [
            { type: 'number', message: '吨位必须为数字值',
              transform (value) {
                if(value==undefined){
                  return null
                }
                return Number(value)
              }
            }
          ],
        bottomTonnage:
          [
            { type: 'number', message: '吨位必须为数字值',
              transform (value) {
                if(value==undefined){
                  return null
                }
                return Number(value)
              }
            }
          ]
      },
      kaiguan1:false,
      kaiguan2:false,
      addShipLineTransPayInfo:{inputBill:'40',inputBill1:null,company:null,taxFreight:null,payBill:null},
      editableTabsValue:"1",
      tabIndex: 0,
      tabIndexValue:1,
      ships: [],
      userList: [],
      linelist: [],
      linelistselect: null,
      shipBusinessTypeList: [],
      portList: [],
      demurrage:true,
      showAdd:false,
      isAddMode:true,
      supplierList:[],
      settleCompanyList:[],
      linelistselectShip:1,
      productlist:[],
      contractCode:null,
      recontractCode: null,
      userListyewu:[],
      kaiguan:false,
      addShipLineInfo: {
        shipline:[{
          voyageNumber: "",
          shipTime:null,
          dingjin:null,
          demurrage:null,
          demurrageTonnage:null,
          upDownLoadingTime:null,
          sysShiplineId:null,
          contractCode:null,
          settleCompany:null,
          reportCompany: null,
          onAccountDiff:null,
        }],
        editableTabs: [{
          title: '请选择船价',
          name: '1',
          payBill:null,
          shipPayId:null,
        }],
      },
      cishu:18,
      shipobj:null,
      delList:[],
      danZhengList:[],
      disabledUpdate: false,
    };
  },
  props: {
    keyStr: String,//数据对象中的key对应的字符
    valStr: String,//数据对象中展示文本对应的字符
  },
  created() {
    getAllSysSupplier().then(res=>{
      if (res!=undefined&&res.resultCode === ERR_OK) {
        this.supplierList = res.list
      }
    })
    if(this.huowuTypelist==null
      ||this.huowuTypelist.length<=0
      ||this.hetongTypelist==null
      ||this.hetongTypelist.length<=0 || this.accountingTypeList==null || this.accountingTypeList.length<=0){
      getDictionaryList("goods_type,contract_company,accounting_type").then(res=>{
        if (res!=undefined&&res.resultCode === ERR_OK) {
          this.huowuTypelist = res.map['goods_type']
          this.hetongTypelist = []
          for(var i=0;i<res.map["contract_company"].length;i++){
            if(res.map["contract_company"][i].code == 25){
            }else if(res.map["contract_company"][i].code == 130){
            }else {
              this.hetongTypelist.push(res.map["contract_company"][i])
            }
          }
          this.reportPortCompany = res.map['contract_company'].filter(item => item.spare3 == 0)
          this.accountingTypeList = res.map['accounting_type'].map(item => {
            return {
              label: item.value,
              value: item.code
            }
          })
        }
      })
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    setDanzheng(obj,res){
      res.danzhengUser = obj.id
    },
    selectHetong(value){
      this.recontractCode = null
      let code = value.code
      if (value.spare3 != 1){
        this.isShow = false
        // if(this.contractCode==code){
        //   this.contractCode = null
        // }else{
        //   this.contractCode = code
        // }
      }else {
        this.isShow = true
      }
      this.contractCode = code
      if(this.addShipLineInfo.shipline[0].contractCode == code){
        this.addShipLineInfo.shipline[0].contractCode=null
      } else {
        this.addShipLineInfo.shipline[0].contractCode = code
      }
    },
    selectReportPortCompany(code){
      if(this.addShipLineInfo.shipline[0].baoCompany == code){
        this.addShipLineInfo.shipline[0].baoCompany=null
      } else {
        this.addShipLineInfo.shipline[0].baoCompany = code
      }
      if(this.recontractCode==code){
        this.recontractCode = null
      }else{
        this.recontractCode = code
      }
    },
    changgedemurrage(){
      this.addShipLineInfo.shipline[0].demurrage = 0;
      this.addShipLineInfo.shipline[0].demurrageTonnage = 0;
      this.demurrage = !this.demurrage
    },
    openModfyPanel(object,a){
      // this.init()
      this.ttle = "修改船期"
      this.showsave = false
      if(a === 1){
        this.showsave = true
      }
      this.delList = []
      this.editableTabsValue="1"
      this.tabIndex = 0
      this.showAdd = true;
      this.isAddMode = false;
      if (a === 1){
        this.ttle = "查看船期"
      }
      this.addShipLineInfo.shipline = Object.assign([], object);
      // for(var i=0;i<this.linelist.length;i++){
      //   var t = this.linelist[i]
      //   if(t.id ==  Number(this.addShipLineInfo.shipline[0].sysShiplineId)){
      //     this.linelistselect = i
      //     break;
      //   }
      // }
      // console.info(this.linelistselect)
      var obj = this.addShipLineInfo.shipline[0]
      if(obj.onAccountDiff == 1){
        this.kaiguan = true
      } else {
        this.kaiguan = false
      }
      // 判断是否滞期费
      if(obj.demurrageTonnage){
        this.demurrage = false
      } else {
        this.demurrage = true
      }
      console.info(obj)
      this.contractCode = obj.contractCode
      this.recontractCode = obj.baoCompany
      if(this.contractCode == 10 || this.contractCode == 20){
          this.isShow = false
        }else {
          this.isShow = true
        }
      var querydata = {
        shipLineId:obj.id
      }
      getShipPayByShipLineId(querydata).then(res =>{
        if(res && res.list && res.list.length>0){
          console.log(res)
          this.addShipLineInfo.editableTabs = []
          this.tabIndexValue = res.list.length
          for(var i=0;i<res.list.length;i++){
            var t = res.list[i]
            var item = {}
            item.title = "请选择船价"+(i !=0 ? i:"")
            item.name = (i+1).toString()
            item.shipPay = t.shipPay
            item.settleTonnage = t.settleTonnage
            item.bottomTonnage = t.bottomTonnage
            item.isBaochuanMoney = t.isBaochuanMoney == 1 ? true : false
            item.baochuanMoney = t.baochuanMoney
            item.yuguSettleTonnage = t.yuguSettleTonnage
            item.payBill = t.payBill
            item.shipPayId = t.id
            item.startPort = t.startPort
            item.endPort = t.endPort
            item.loadWharf = t.loadWharf
            item.finalWharf = t.finalWharf
            item.startPort2 = t.startPort2
            item.endPort2 = t.endPort2
            item.loadWharf2 = t.loadWharf2
            item.finalWharf2 = t.finalWharf2
            item.goodsType = t.goodsType
            this.addShipLineInfo.editableTabs.push(item)
            this.$nextTick(function () {
              if(t.startPort){
                this.$refs.start[this.tabIndex].choseKey(t.startPort);
              }
              if(t.endPort){
                this.$refs.endport[this.tabIndex].choseKey(t.endPort);
              }
              if(t.loadWharf){
                this.$refs.zhuangzai[this.tabIndex].choseKey(t.loadWharf);
              }
              if(t.finalWharf){
                this.$refs.mudi[this.tabIndex].choseKey(t.finalWharf);
              }
              if(t.startPort2){
                this.$refs.start2[this.tabIndex].choseKey(t.startPort2);
              }
              if(t.endPort2){
                this.$refs.endport2[this.tabIndex].choseKey(t.endPort2);
              }
              if(t.loadWharf2){
                this.$refs.zhuangzai2[this.tabIndex].choseKey(t.loadWharf2);
              }
              if(t.finalWharf2){
                this.$refs.mudi2[this.tabIndex].choseKey(t.finalWharf2);
              }
              if(t.goodsType){
                this.$refs.huowuleixing[this.tabIndex].choseKey(t.goodsType);
              }
            })
          }
        } else {
          this.addShipLineInfo.editableTabs = [{
            title: '请选择船价',
            name: '1',
            payBill:null,
          }]
        }
      })
      if(obj.shipownerCompanyId){
        this.getSettleCompanyList(obj.shipownerCompanyId)
      }
      this.$nextTick(function () {
        if(obj.shipId){
          this.$refs.shipred.choseKey(obj.shipId);
        }
        if(obj.findShipUser && obj.businessType != 10){
          this.$refs.yewuyuan.choseKey(obj.findShipUser);
        }
        if(obj.danzhengUser){
          this.$refs.danzhengUser.choseKey(obj.danzhengUser);
        }
        if(obj.businessType){
          this.$refs.chuanboleixing.choseKey(obj.businessType);
        }
        if(obj.shipownerCompanyId){
          this.$refs.supplier.choseKey(obj.shipownerCompanyId);
        }
        if(obj.settleCompany){
          this.$refs.settleSupplier.choseKey(obj.settleCompany);
        }
      });


      const danzhengUser = this.addShipLineInfo.shipline[0].danzhengUser;
      if ( danzhengUser == null || danzhengUser == '' ) {
        this.disabledUpdate = false;
      } else if (danzhengUser == this.$store.getters.getMyUserInfo.id) {
        this.disabledUpdate = false;
      } else {
        this.disabledUpdate = true;
      }
    },
    setdiancompany(obj){
      console.log(obj)
      this.addShipLineTransPayInfo.dianCompany = obj.code
    },
    setmaicompany(obj){
      console.log(obj)
      this.addShipLineTransPayInfo.maiCompany = obj.code
    },
    leixingaddtaxib(id){
      if(this.addShipLineTransPayInfo.inputBill == id){
        this.addShipLineTransPayInfo.inputBill=null
      } else {
        this.addShipLineTransPayInfo.inputBill = id
      }
    },
    leixingaddtaxib1(id){
      if( this.addShipLineTransPayInfo.inputBill1 == id){
        this.addShipLineTransPayInfo.inputBill1=null
      } else {
        this.addShipLineTransPayInfo.inputBill1 = id
      }
    },
    leixingaddtaxCC(id){
      if(this.formLabelAlign.editableTabs[this.tabIndex].company == id){
        this.formLabelAlign.editableTabs[this.tabIndex].company=null
      } else {
        this.formLabelAlign.editableTabs[this.tabIndex].company = id
      }
    },
    leixingaddtaxpb(id){
      console.log(this.addShipLineInfo)
      if( this.addShipLineInfo.editableTabs[this.tabIndex].payBill == id){
        this.addShipLineInfo.editableTabs[this.tabIndex].payBill=null
      } else {
        this.addShipLineInfo.editableTabs[this.tabIndex].payBill = id
      }
    },
    kongzhi(){
      console.log(11111)
      this.kaiguan2 = this.kaiguan1
    },
    clickTab(tabobj){
      this.tabIndex = tabobj.index
      console.log("当前选中的this.tabIndex = "+this.tabIndex )
      var t = this.addShipLineInfo.editableTabs[this.tabIndex]
      this.$nextTick(function () {
        if(t.startPort){
          this.$refs.start[this.tabIndex].choseKey(t.startPort);
        }
        if(t.endPort){
          this.$refs.endport[this.tabIndex].choseKey(t.endPort);
        }
        if(t.loadWharf){
          this.$refs.zhuangzai[this.tabIndex].choseKey(t.loadWharf);
        }
        if(t.finalWharf){
          this.$refs.mudi[this.tabIndex].choseKey(t.finalWharf);
        }
        if(t.startPort2){
          this.$refs.start2[this.tabIndex].choseKey(t.startPort2);
        }
        if(t.endPort2){
          this.$refs.endport2[this.tabIndex].choseKey(t.endPort2);
        }
        if(t.loadWharf2){
          this.$refs.zhuangzai2[this.tabIndex].choseKey(t.loadWharf2);
        }
        if(t.finalWharf2){
          this.$refs.mudi2[this.tabIndex].choseKey(t.finalWharf2);
        }
        if(t.goodsType){
          this.$refs.huowuleixing[this.tabIndex].choseKey(t.goodsType);
        }
      })
    },
    addTab(targetName) {
      let newTabName = ++this.tabIndexValue + '';
      // let time = new Date().getTime().toString().substring(new Date().getTime().toString().length-5)
      var len = this.addShipLineInfo.editableTabs.length

      this.tabIndex = len;

      let title = "船价-"+ len
      if(len == 0){
        title = "船价"
      }
      this.addShipLineInfo.editableTabs.push({
        title: title,
        name: newTabName,
        payBill:null,
        isBaochuanMoney:0,
      });
      this.editableTabsValue = newTabName;
    },
    removeTab(targetName) {
      this.$confirm('此操作将删除该船价, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let tabs = this.addShipLineInfo.editableTabs;
        let activeName = this.editableTabsValue;
        if (activeName === targetName) {
          tabs.forEach((tab, index) => {
            if (tab.name === targetName) {
              let nextTab = tabs[index + 1] || tabs[index - 1];
              if (nextTab) {
                activeName = nextTab.name;
              }
            }
          });
        }

        this.editableTabsValue = activeName;
        for(var i=0;i<tabs.length;i++){
          var tab = tabs[i]
          if(tab.name === targetName){
            if(tab.shipPayId){
              this.delList.push(tab.shipPayId)
            }
          }
        }
        this.addShipLineInfo.editableTabs = tabs.filter(tab => tab.name !== targetName);
        console.info(this.delList)
        for (var i = 0; i < this.addShipLineInfo.editableTabs.length; i++) {
          var tmp = this.addShipLineInfo.editableTabs[i];
          if (i == 0) {
            tmp.title = "船价"
          } else {
            tmp.title = "船价-" + i
          }
        }
        if (this.tabIndexRecord == parseInt(targetName) - 1) {
          this.tabIndexRecord = null
        } else if (this.tabIndexRecord > parseInt(targetName) - 1) {
          this.tabIndexRecord = this.tabIndexRecord - 1
        }
        this.tabIndex = this.tabIndex - 1
        console.info("this.tabIndexRecord=", this.tabIndexRecord)
        console.log("当前选中的this.tabIndex = " + this.tabIndex)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    selectline(item){
      // this.linelistselect = idx;
      this.addShipLineInfo.shipline[0].sysShiplineId = item.id;
    },
    setShipLeixing(obj) {
      this.addShipLineInfo.shipline[0].businessType = obj.code;
      // if(obj.code === 10){
      //   this.addShipLineInfo.shipline[0].findShipUser = "1333961561353486337";
      // }
    },
    setSupplier(obj){
      this.getSettleCompanyList(obj.id)
      this.$refs.settleSupplier.clean()
      this.addShipLineInfo.shipline[0].shipownerCompanyId = obj.id
    },
    setSettleSupplier(obj){
      this.addShipLineInfo.shipline[0].settleCompany = obj.id
    },
    getSettleCompanyList(id){
      getSettleCompanyList(id).then(res=>{
        if (res != undefined && res.resultCode === ERR_OK) {
          this.settleCompanyList = res.list
        }
      })
    },
    handleClose(){
      this.showAdd = false
      this.isShow = false
    },
    setEndPort(obj) {
      this.addShipLineInfo.editableTabs[this.tabIndex].endPort = obj.id;
    },
    setStartPort(obj) {
      console.log('startport',obj)
      this.addShipLineInfo.editableTabs[this.tabIndex].startPort = obj.id;
      console.log('sport',this.addShipLineInfo.editableTabs[this.tabIndex].startPort)
    },
    setMudi(obj){
      this.addShipLineInfo.editableTabs[this.tabIndex].finalWharf = obj.id
    },
    setZhuangzai(obj){//设置装载码头
      this.addShipLineInfo.editableTabs[this.tabIndex].loadWharf = obj.id
    },
    setEndPort2(obj) {
      this.addShipLineInfo.editableTabs[this.tabIndex].endPort2 = obj.id;
    },
    setStartPort2(obj) {
      this.addShipLineInfo.editableTabs[this.tabIndex].startPort2 = obj.id;
    },
    setMudi2(obj){
      this.addShipLineInfo.editableTabs[this.tabIndex].finalWharf2 = obj.id
    },
    setZhuangzai2(obj){//设置装载码头
      this.addShipLineInfo.editableTabs[this.tabIndex].loadWharf2 = obj.id
    },
    setHLeixing(obj){
      console.log("设置了货物类型！")
      console.log(obj)
      this.addShipLineInfo.editableTabs[this.tabIndex].goodsType = obj.code
    },
    setLeixing(obj){
      this.queryForm.businessType = obj.id
    },
    setZuchuanyuan(obj) {
      this.addShipLineInfo.shipline[0].findShipUser = obj.id;
    },
    setDanzhengyuan(obj) {
      this.addShipLineInfo.shipline[0].danzhengUser = obj.id;
    },
    setShip(obj) {
      this.addShipLineInfo.shipline[0].shipId = obj.id;
      this.addShipLineInfo.shipline[0].tonnage = obj.deadWeight;
    },

    init() {
      this.$store.dispatch('getAllUserListSaveInVuex').then(res=>{
        if(res){
          console.log('====---',res);
          this.userListyewu = res.yewu.filter(tmp=>tmp.source === 'ship')
          this.danZhengList = res.danzhengShip
        }
      })
      getDictionaryList("ship_business_type,bill_tax,contract_company,dian_company,mai_company").then((res) => {
        if (res != undefined && res.resultCode === ERR_OK) {
          this.dictionaryLists = res.map;
          this.shipBusinessTypeList = res.map["ship_business_type"];
          this.diancompanylist = res.map['dian_company']
          this.maicompanylist = res.map['mai_company']
          this.hetongTypelist = []
          for(var i=0;i<res.map["contract_company"].length;i++){

            if(res.map["contract_company"][i].code == 25){
            }else if(res.map["contract_company"][i].code == 130){
            }else {
              this.hetongTypelist.push(res.map["contract_company"][i])
            }
            // if(res.map["contract_company"][i].code != 25){
            //   this.hetongTypelist.push(res.map["contract_company"][i])
            // }
          }
          this.reportPortCompany = res.map['contract_company'].filter(item => item.spare3 == 0)
        }
        // loading.close();
      });
      getIndependentSysShipLine().then((res) => {
        if (res != undefined && res.resultCode === ERR_OK) {
          this.linelist = res.list;
        }
      });
      if(this.wharfList==null
        ||this.wharfList.length<=0){
        getAllSysWharf().then(res=>{
          if (res!=undefined&&res.resultCode === ERR_OK) {
            this.wharfList = res.list
          }
        })
      }
    },
    saveShipLine(){
      this.$refs["addShipLineInfoRef"].validate((valid) => {
        if (valid) {
          this.toSave();
          this.showAdd = false
        } else {
          console.log(this.addShipLineInfo)
          console.log("error submit!!");
          return false;
        }
      });
    },
    updateShipLine(){
      this.$refs["addShipLineInfoRef"].validate((valid) => {
        if (valid) {
          this.toupdate();
          this.showAdd = false
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    toupdate(){
      if (this.addShipLineInfo.shipline[0].dingjin === ""){
        this.addShipLineInfo.shipline[0].dingjin = 0
      }
      if(this.kaiguan){
        this.addShipLineInfo.shipline[0].onAccountDiff = 1
      } else {
        this.addShipLineInfo.shipline[0].onAccountDiff = 0
      }

      //将this.addShipLineInfo 里的 editableTabs 数组里的isBaochuanMoney  == false = 0 true = 1

      for (var i = 0; i < this.addShipLineInfo.editableTabs.length; i++) {
        if (this.addShipLineInfo.editableTabs[i].isBaochuanMoney == false) {
          this.addShipLineInfo.editableTabs[i].isBaochuanMoney = 0
        } else {
          this.addShipLineInfo.editableTabs[i].isBaochuanMoney = 1
        }
      }

      var goodStr = JSON.stringify(this.addShipLineInfo)
      var delListStr = this.delList.toString()
      var goodsjson =  encodeURIComponent(goodStr)
      var query = {
        goodsjson:goodsjson,
        delListStr:delListStr
      }
      updateShipLineNew(query).then(res=>{
        if (res != undefined && res.resultCode === ERR_OK) {

          this.$message({
            type: "success",
            message: "修改成功!",
          });

          this.$emit("addShipSuccess")
        }
      })
    },
    toSave() {
      if (this.addShipLineInfo.shipline[0].dingjin === ""){
        this.addShipLineInfo.shipline[0].dingjin = 0
      }
      if(this.kaiguan){
        this.addShipLineInfo.shipline[0].onAccountDiff = 1
      } else {
        this.addShipLineInfo.shipline[0].onAccountDiff = 0
      }
      //将this.addShipLineInfo 里的 editableTabs 数组里的isBaochuanMoney  == false = 0 true = 1

      for (var i = 0; i < this.addShipLineInfo.editableTabs.length; i++) {
        if (this.addShipLineInfo.editableTabs[i].isBaochuanMoney == true) {
          this.addShipLineInfo.editableTabs[i].isBaochuanMoney = 1
        } else {
          this.addShipLineInfo.editableTabs[i].isBaochuanMoney = 0
        }
      }
      var goodStr = JSON.stringify(this.addShipLineInfo)
      var goodsjson =  encodeURIComponent(goodStr)
      saveShipLine1(goodsjson).then((res) => {
          if (res != undefined && res.resultCode === ERR_OK) {

            this.$message({
              type: "success",
              message: "新增成功!",
            });

            this.$emit("addShipSuccess")
            // this.topage(1);
            // this.getallvoyageNumber();
          }
        });
    },
    generatevoyageNumber(){
      genVoyageNumber(0).then(res=>{
        this.addShipLineInfo.shipline[0].voyageNumber = res.vnnum
      })
        // var date = dayjs().format('YYYYMM')
        // var pp = date + (this.cishu++)
        // this.addShipLineInfo.voyageNumber = Number(pp) + 1
    },
    selectShipline(index){
      this.linelistselectShip = index
    },
    adddata() {},
    showAddDataView() {
      // this.init()
      this.ttle="新增船期"
      this.showsave = false
      this.showAdd = true
      this.isAddMode = true
      this.clean()
      this.editableTabsValue="1"
      this.tabIndex = 0
      this.tabIndexValue = 1
      this.kaiguan = false
    },
    modBHS(){
      var bhs = this.addShipLineInfo.editableTabs[this.tabIndex].shipPay
      if(!bhs){
        return
      }
      var sl = this.addShipLineInfo.editableTabs[this.tabIndex].payBill


      var slNum = this.getSlNum(sl)

      if(slNum!=null){
        var tmp = bhs/(1-slNum);
        this.addShipLineInfo.editableTabs[this.tabIndex].shipPayNo = tmp.toFixed(2)
      }
    },
    modHS(){
      // var bhs = this.addShipLineInfo.editableTabs[this.tabIndex].freightNo
      var hs = this.addShipLineInfo.editableTabs[this.tabIndex].shipPayNo
      var sl = this.addShipLineInfo.editableTabs[this.tabIndex].payBill

      var slNum = this.getSlNum(sl)
      if(slNum!=null){
        var tmp = hs*(1-slNum)
        this.addShipLineInfo.editableTabs[this.tabIndex].shipPay = tmp.toFixed(2)
      }
    },
    getSlNum(key){
      if(key==20){
        return 0.01;
      }else if(key==30){
        return 0.06;
      }else if(key==40){
        return 0.09;
      }else if(key==50){
        return 0.13;
      }
      return null;
    },
    clean() {
      // this.linelistselect = null
      this.$nextTick(function () {
        if(this.addShipLineInfo.shipline[0].businessType !==10){
          this.$refs.yewuyuan.clean();
        }
        this.addShipLineInfo = {
          shipline:[{
            voyageNumber: "",
            shipTime:null,
            dingjin:null,
            demurrage: null,
            demurrageTonnage:null,
            upDownLoadingTime:null,
            sysShiplineId:null,
            contractCode:null,
            settleCompany: null,
            accountingType:null,
          }],
          editableTabs: [{
            title: '船价',
            name: '1',
            payBill:null,
            shipPayId:null,
            shipPay:null,
          }],
        },
        this.contractCode = null
        this.$refs.shipred.clean();
        this.$refs.chuanboleixing.clean();
        this.$refs.supplier.clean();
        this.$refs.settleSupplier.clean();
        this.$refs.start[this.tabIndex].clean();
        this.$refs.endport[this.tabIndex].clean();
        this.$refs.zhuangzai[this.tabIndex].clean();
        this.$refs.mudi[this.tabIndex].clean();
        this.$refs.start2[this.tabIndex].clean();
        this.$refs.endport2[this.tabIndex].clean();
        this.$refs.zhuangzai2[this.tabIndex].clean();
        this.$refs.mudi2[this.tabIndex].clean();
        this.$refs.huowuleixing[this.tabIndex].clean();
        this.$refs["addShipLineInfoRef"].resetFields();
      });
    },


    matchingHeSuanQuYu(){

      let startPort =  this.addShipLineInfo.editableTabs[this.tabIndex].startPort

      //核算区域不要做成选填，根据租船单证员录的起运港直接确定核算区域，
      // 起运港是大连、丹东的核算区域是大连 ；起运港是莆田的，核算区域为莆田，起运港算鲅鱼圈区域，其他手动选择

      if(!startPort){
        this.$message({
          message: '请先选择起运港',
          type: 'warning'
        });
      } else if(startPort == "0000002002" || startPort == "0000002001"){
        this.addShipLineInfo.shipline[0].accountingType = 3
      }else if(startPort == "0000006026") {
        this.addShipLineInfo.shipline[0].accountingType = 4
      }else if(startPort == "0000002004") {
        this.addShipLineInfo.shipline[0].accountingType = 2
      }else{
        this.$message({
          message: '没有匹配到核算区域，请手动选择',
          type: 'warning'
        });
      }
    },

    calculatePrice(tabIndex){
      console.log("当前选中的this.tabIndex = "+tabIndex )
      var info = this.addShipLineInfo.editableTabs[tabIndex]

      console.log("当前选中的t = "+JSON.stringify(info) )

      if(info.isBaochuanMoney != true){
        this.$message({
          message: '请先勾选是否包船',
          type: 'warning'
        });
        return
      }

      if(!info.baochuanMoney ){
        this.$message({
          message: '请先填写包船金额',
          type: 'warning'
        });
        return
      }

      if(!info.settleTonnage && !info.yuguSettleTonnage ){
        this.$message({
          message: '请先填写预估吨位和结算吨位',
          type: 'warning'
        });
        return
      }

      let tonnage = info.settleTonnage || info.yuguSettleTonnage

      console.log("当前选中的tonnage = "+tonnage )

      let price = info.baochuanMoney / tonnage;

      //保留8位
      price = price.toFixed(8)
      console.log("当前选中的price = "+price )

      this.addShipLineInfo.editableTabs[tabIndex]['shipPay'] = price;
      if(!info.settleTonnage){
        this.addShipLineInfo.editableTabs[tabIndex]['settleTonnage'] = tonnage;
      }
    }
  },
  components: {
    PanelQuerySelection,
    PanelSelection,
    SimplePanelSelection,
    PanelSimpleSelection,
    NewPanelQuerySelection
  },
};
</script>
<style scoped>
.sp_add_left {
  width: 45%;
  margin-right: 5%;
}
.sp_add_right {
  width: 45%;
}
.dialog-footer {
  margin-right: 5%;
}
  .myform .myclass .el-input{
    width: 100%;
  }
  .chuandongjiesuan >>> .el-form-item__label{
    position:relative;
    right: 10px;
    white-space:nowrap;
  }
</style>
